<template>
  <div class="productCen">
    <!-- 轮播图 -->
    <div class="carousel">
      <el-carousel :interval="5000" arrow="always">
        <el-carousel-item v-for="(item,index) in slidelist" :key="index">
          <img :src="item.filepath" alt="" />
          <div class="text">
            <div class="title">{{item.title}}</div>
            <div class="line"></div>
            <div class="subTitle">智能建筑综合管理平台</div>
            <div class="content">
                {{item.desc}}
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 卡片部分 -->
    <div class="cards">
      <div class="tabs">
        <ul>
          <li :class="[tabActive == 2 ? 'activeTab' : '']" @click="chooseTab(2)">
            所有
          </li>
          <li :class="[tabActive == 3 ? 'activeTab' : '']" @click="chooseTab(3)">
            智慧资产
          </li>
          <li :class="[tabActive == 4 ? 'activeTab' : '']" @click="chooseTab(4)">
            智慧医疗
          </li>
          <li :class="[tabActive == 5 ? 'activeTab' : '']" @click="chooseTab(5)">
            智慧园区
          </li>
        </ul>
      </div>
      <div>
        <transition-group name="fade" appear tag="div" class="tabItems">
          <div class="card" v-for="item in cardInfo" :key="item.id" @click="gotoDetail(item.id)">
            <div class="top">
              <img :src="item.thumb" alt="" />
            </div>
            <div class="bottom">
              <div class="title">{{ item.title }}</div>
              <div class="content">{{ item.desc }}</div>
              <div class="more">
                阅读更多&nbsp;&nbsp;&nbsp;<i class="el-icon-right"></i>
              </div>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
    <!-- 定制部分 -->
    <div class="book">
      <img src="../assets/images/productCenter/banner.jpg" alt="" />
      <div class="title">
        我们也可以根据您的业务需要，为您定制化开发...
        <span class="line1"></span>
        <span class="line2"></span>
      </div>
      <div class="bookItem">
        <div class="itemLeft">
          <div class="title1">
            <span class="main">PC端应用</span>
            <span class="sub">中大型线上零售企业管理平台</span>
          </div>
          <div class="content">
            ERP企业版提供开发API接口，可与第三方系统或线下ERP系统无缝对接。同时可与众多第三方仓储公司实现实时数据交换，保证了运营和仓储的实时性，适用于大数据量查询等资源消耗性操作。
          </div>
          <el-button type="primary">立即定制</el-button>
        </div>
        <img src="../assets/images/productCenter/icon01.png" alt="" class="img1" />
      </div>
      <div class="bookItem">
        <img src="../assets/images/productCenter/icon02.png" alt="" class="img2" />
        <div class="itemRight">
          <div class="title1">
            <span class="main">移动APP开发</span>
            <span class="sub">中大型线上零售企业管理平台</span>
          </div>
          <div class="content">
            移动应用软件ECM专注开发中大型移动APP，我们可以为客户开发基于苹果、安卓的APP应用，根据客户的不同需求开发框架型、原生型（native
            app）和轻量级APP。
          </div>
          <el-button type="primary">立即定制</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "first",
      cardInfoActive: [],
      activeBtn: 1,

      tabActive: 2,
      cardInfo: [],
      slidelist: [],
    };
  },
    created() {
        this.getslidelist();
        this.getarticlelist();
    },
  mounted() {
    this.cardInfoActive = this.cardInfo.slice(0);
  },
  methods: {
      getslidelist() {
          let self = this;
          var url = "index/slide_list?slide_id=2";
          self.$axios.get(self.api.apiurl + url).then(function (res) {
              self.slidelist = res.data.data.list;
          })
      },
      getarticlelist() {
          let self = this;
          var url = "index/article_list?cate_id="+this.tabActive;
          self.$axios.get(self.api.apiurl + url).then(function (res) {
              self.cardInfo = res.data.data.list;
          })
      },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    chooseTab(val) {
      this.tabActive = val;
        let self = this;
        var url = "index/article_list?cate_id="+val;
        self.$axios.get(self.api.apiurl + url).then(function (res) {
            self.cardInfo = res.data.data.list;
        })
      /*if (this.tabActive == 1) {
        this.cardInfoActive = this.cardInfo.slice(0);
      } else if (this.tabActive == 2) {
        this.cardInfoActive = this.cardInfo.slice(0, 3);
      } else if (this.tabActive == 3) {
        this.cardInfoActive = this.cardInfo.slice(3, 7);
      } else if (this.tabActive == 4) {
        this.cardInfoActive = this.cardInfo.slice(7);
      }*/
    },
    gotoDetail(val) {
      this.$router.push(`/productCenter/detail/${val}`);
    },
    goDetail(val) {
      let index = val;
      this.$parent.showProductDetail(index);
    },
  },
};
</script>

<style lang="scss" scoped>
.productCen {
  .carousel {
    .text {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 99;
      width: 100%;
      height: 100%;
      text-align: center;
      background-color: rgba(0, 0, 0, 0.3);
      padding-top: 8rem;

      .title {
        font-size: 4.2rem;
        font-weight: 200;
        color: #fff;
        margin-bottom: 2rem;
      }

      .line {
        width: 12rem;
        height: 0.5rem;
        margin: 0 auto;
        background-color: #3d8bed;
        margin-bottom: 2rem;
      }

      .subTitle {
        font-size: 3rem;
        font-weight: 200;
        color: #fff;
        margin-bottom: 2rem;
      }

      .content {
        font-size: 2rem;
        font-weight: 200;
        color: #fff;
        width: 100rem;
        margin: 0 auto;
      }
    }
  }

  .cards {
    padding-top: 5rem;
    width: 192rem;

    .tabs {
      width: 100rem;
      height: 6rem;
      margin: 0 auto;

      ul {
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;

        li {
          list-style-type: none;
          margin: 0;
          padding: 0 2rem;
          height: 3.5rem;
          line-height: 3.5rem;
          font-size: 2rem;
          color: rgba(0, 0, 0, 0.55);
          border-radius: 1.8rem;
          cursor: pointer;
        }

        li:hover {
          color: #fff;
          background-color: #3d8bed;
        }

        .activeTab {
          color: #fff;
          background-color: #3d8bed;
        }
      }
    }

    .tabItems {
      width: 130rem;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;

      .card {
        width: 41rem;
        height: 61rem;
        border-radius: 1rem;
        overflow: hidden;
        border: 0.1rem solid #ececec;
        cursor: pointer;
        margin-bottom: 3rem;
        text-decoration: none;

        .top {
          overflow: hidden;

          img {
            width: 100%;
            height: 40rem;
            transition: all 1s linear;
          }

          img:hover {
            transition: 1s;
            transform: scale(1.1);
          }
        }

        .bottom {
          .title {
            text-align: left;
            font-size: 2.4rem;
            color: black;
            padding: 1rem 0 1rem 1.5rem;
          }

          .content {
            // height: 8rem;
            text-align: left;
            font-size: 1.4rem;
            color: rgb(83, 81, 81);
            padding: 1rem 1.5rem 0;
            line-height: 1.5;
          }


          .more {
            text-align: left;
            font-size: 1.4rem;
            color: #85a1de;
            padding: 2rem 0 1rem 1.5rem;
          }
        }
      }
    }

    .pagination {
      padding: 1.5rem 0 3.5rem 0;

      .activeBtn {
        background: #f7fafe;
        border-color: #fff;
        color: black;
      }
    }
  }

  .book {
    width: 100%;

    img {
      width: 100%;
    }

    .title {
      font-size: 3.2rem;
      font-weight: 600;
      text-align: center;
      padding: 3rem 0;
      position: relative;

      .line1 {
        display: inline-block;
        position: absolute;
        width: 8rem;
        height: 0.2rem;
        background-color: #0ca2ea;
        left: 48rem;
        top: 5rem;
      }

      .line2 {
        display: inline-block;
        position: absolute;
        width: 8rem;
        height: 0.2rem;
        right: 48rem;
        top: 5rem;
        background-color: #0ca2ea;
      }
    }

    .bookItem {
      width: 128rem;
      margin: 0 auto;
      padding: 3rem 0;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;

      .img1 {
        width: 40%;
      }

      .img2 {
        width: 30%;
      }

      .itemLeft {
        width: 70rem;
        padding-left: 4rem;
        padding-top: 3rem;

        .title1 {
          .main {
            display: inline-block;
            font-size: 3.6rem;
            font-weight: 500;
            color: black;
            margin-right: 3rem;
          }

          .sub {
            display: inline-block;
            font-size: 2rem;
            color: black;
          }
        }

        .content {
          width: 50rem;
          font-size: 1.8rem;
          color: #8f8f8f;
          line-height: 1.5;
          padding: 3rem 0 7rem 0;
        }
      }

      .itemRight {
        width: 60rem;
        margin-left: 35rem;
        padding-top: 9rem;

        .title1 {
          .main {
            display: inline-block;
            font-size: 3.6rem;
            font-weight: 500;
            color: black;
            margin-right: 3rem;
          }

          .sub {
            display: inline-block;
            font-size: 2rem;
            color: black;
          }
        }

        .content {
          width: 50rem;
          font-size: 1.8rem;
          color: #8f8f8f;
          line-height: 1.5;
          padding: 3rem 0 7rem 0;
        }
      }
    }
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
    transform: translateY(80px);
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: all 1s ease;
  }

  .fade-move {
    transition: all 1.1s ease;
  }

  .fade-leave-active {
    position: absolute;
  }
}

@media screen and (max-width: 750px) {
  .productCen{
    .carousel{
      .text{

        .title{
          font-size: 7.2rem;
          margin-top: 5rem;
        }
        .content{
          display: none;
        }
      }

    }
    .cards{
      padding-top: 7rem;
      .tabs{
        width: 150rem;
        height: 20rem;

        ul{


          li{
            height: 9.5rem;
            line-height: 8.5rem;
            font-size: 9rem;
          }
        }
      }
      .tabItems{
        width: 90%;
        margin: 0 auto;
        .card{
          width: 47%;
          height: 120rem;
          margin-bottom: 10rem;
          .top{
            img{
              height: 60rem;
            }
          }

          .title{
            font-size: 8rem !important;
          }

            .content{
                height: 28rem;
                overflow: hidden;
          }
        }
      }
    }
    .book{
        display: none;
      img{
        height: 150px;
      }
      .title{
        font-size: 8rem;
        .line1{
        display: none;
      }
      .line2{
        display: none;
      }
      }

    }
  }
}


</style>
<style lang="scss">
.productCen {
  .el-carousel__item img {
    width: 100%;
    height: 100%;
  }

  .el-carousel--horizontal {
    overflow-x: hidden;
    width: 100%;
  }

  .el-carousel__container {
    height: 46rem !important;
  }

  .el-tabs__nav-wrap::after {
    background-color: #fff;
  }

  .cards {
    .el-button {
      background: #6266ea;
      border-color: #6266ea;
      color: #fff;
    }

    .el-button:hover {
      background: #7a7ded;
      border-color: #7a7ded;
      color: #fff;
    }
  }
}
</style>
